import { expand } from 'uri-template-lite';

import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import { apiClient } from '../../common/ApiClient';
import { InputDataLoadingAction } from '../schema/types';
import { InputDataUrl } from './InputDataUrl';

const postInputDataUploadAction = (
  request: InputDataLoadingAction,
  headers?: HttpHeaders
) =>
  apiClient
    .post(
      expand(InputDataUrl.INPUT_DATA_EXCEL_ACTION, { action: request.action }),
      {
        filePath: request.filePath,
        metadata: request.metadata,
      },
      headers ? { headers } : undefined
    )
    .then((response) => response.data);

export const useMutateInputDataUploadAction = createApiMutationHook(
  ['inputDataUploadAction'],
  getMutationFn(postInputDataUploadAction)
);
